import { render, staticRenderFns } from "./combo.vue?vue&type=template&id=92830ff6&scoped=true&"
import script from "./combo.vue?vue&type=script&lang=js&"
export * from "./combo.vue?vue&type=script&lang=js&"
import style0 from "./combo.vue?vue&type=style&index=0&id=92830ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92830ff6",
  null
  
)

export default component.exports